exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-table td {\n  white-space: nowrap; }\n\n.ant-table th {\n  white-space: nowrap; }\n\n.ant-table-body {\n  overflow-x: auto !important; }\n", ""]);

// exports
